// fånga vite preload error tidigt
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault(); // stoppa att felet kastas vidare
  console.error('Vite preload error, reloading...', event);
  window.location.reload();
});

import 'core-js';
import 'regenerator-runtime/runtime';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import AppRoot from 'app';
import { IntlProvider } from 'react-intl';
import { getMessages } from 'localization';
import 'assets/styles/index.scss';
import '@entur/a11y/dist/styles.css';
import ErrorBoundary from './app/components/ErrorBoundary';
import { DEPLOYMENT } from 'config';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
dayjs.extend(customParseFormat);
dayjs.extend(duration);

//eslint-disable-next-line
console.log(`%c Loading v${__APP_VERSION__} (${DEPLOYMENT})`, 'font-size:12px; font-weight:bold; color:green;');

const messages = getMessages();
const errorFunction = () => '';

const container = document.getElementById('app');
if (container) {
  const root = createRoot(container);

  root.render(
    <BrowserRouter>
      <NuqsAdapter>
        <IntlProvider locale="sv" messages={messages} onError={errorFunction}>
          <ErrorBoundary>
            <AppRoot />
          </ErrorBoundary>
        </IntlProvider>
      </NuqsAdapter>
    </BrowserRouter>
  );
} else {
  console.error('Failed to find the app container element.');
}
